import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=a4797eca&scoped=true&"
import script from "./Backup.vue?vue&type=script&lang=js&"
export * from "./Backup.vue?vue&type=script&lang=js&"
import style0 from "./Backup.vue?vue&type=style&index=0&id=a4797eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4797eca",
  null
  
)

export default component.exports